export default __webpack_public_path__ + "static/media/smtp2go-negative.f0465397.svg";